import { Banner, BannerAction, BannerIcon, BannerTitle } from '@repo/ui/components/ui/banner'
import { Download } from 'lucide-react'
import { useEffect } from 'react'
import { useOnboarding } from '@/lib/onboarding'
import { useInstallPrompt } from '@/lib/pwa'

export function InstallBanner() {
  const { canPrompt, promptInstall, dismissPrompt, isInstalled } = useInstallPrompt()
  const { markAutoComplete } = useOnboarding()

  useEffect(() => {
    if (!isInstalled) return
    markAutoComplete('install-app').catch(() => undefined)
  }, [isInstalled, markAutoComplete])

  if (!canPrompt) {
    return null
  }

  return (
    <Banner onClose={dismissPrompt} className="border-primary/40 bg-primary/5">
      <BannerIcon icon={Download} />
      <BannerTitle>
        <span className="font-medium">Install the app</span>
        <br />
        <span className="text-sm opacity-90">
          Get quick access from your home screen and stay signed in everywhere.
        </span>
      </BannerTitle>
      <BannerAction onClick={promptInstall}>
        <Download className="mr-2 h-4 w-4" />
        Install
      </BannerAction>
    </Banner>
  )
}
